import React from 'react';
import {PieChart, Legend, Pie, Cell} from 'recharts';
import {Grid, Typography} from '@material-ui/core';

import {CustomizedLegend, LegendPayloadType} from './DashboardChart';
import {MainHeading, WidgetContainer} from './styles';
import COLOR from '../../styled/colors';

const COLORS = ['#417521', '#9DCC5F', '#88B481'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  value,
  index,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return value ? (
    <>
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{
          fontFamily: 'sans-serif',
          fontWeight: 700,
        }}>
        {value}
      </text>
      {/*<text
        x={x}
        y={y + 10}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{
          fontFamily: 'sans-serif',
          fontWeight: 700,
        }}>
        {`${(percent * 100).toFixed(0)}%`}
      </text>*/}
    </>
  ) : (
    <></>
  );
};

export type DashboardChartPieProps = {
  data: Array<{value: number, singleTotal?: boolean}>;
  legend?: LegendPayloadType;
  showTotal?: boolean;
};

export const DashboardChartPie: React.FC<DashboardChartPieProps> = ({
  data,
  legend,
}) => {
  if (data.length === 0) {
    return <Grid item container style={{backgroundColor: COLOR.GRAY_SOLID, padding:30, marginTop: 100, marginBottom: 100}}>
      <Typography>No data to display</Typography>
    </Grid>
  }
  const sum = data.reduce((prev, dt) => prev + dt.value, 0);
  return (
    <PieChart width={500} height={260}>
      <Pie
        data={data}
        cx={120}
        cy={120}
        isAnimationActive={false}
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={125}
        fill="#8884d8"
        dataKey="value"
        style={{
          textAlign: 'center',
        }}>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index]} />
        ))}
      </Pie>
      <Legend
        layout="vertical"
        align="right"
        verticalAlign="middle"
        iconType="circle"
        content={<CustomizedLegend title={legend?.title || ''} showValue={data.map((entry) => (` (${Math.round(entry.value / sum * 100)}%)`))} />}
      />
    </PieChart>
  );
};

type DashboardChartPieWidgetProps = {
  title: string;
  children?: any;
} & DashboardChartPieProps;

const DashboardChartPieWidget: React.FC<DashboardChartPieWidgetProps> = ({
  title,
  data,
  children,
  ...props
}) => {
  let hasData = false;
  let total = 0;
  data.forEach((dt) => {
    hasData = hasData || dt.value > 0
    total += dt.value;
  });
  return (
    <WidgetContainer item container direction="row" style={{padding: 30}}>
      {data.length > 0 && data[0].singleTotal 
        ? <Grid item container style={{paddingRight: 40}}>
          <Grid item container xs={5} style={{textAlign: 'center'}}>
            <MainHeading>{title}</MainHeading>
          </Grid>
          <Grid item container spacing={3} style={{backgroundColor: COLOR.GRAY_SOLID, margin: 'auto', padding: 10}} xs={7} alignItems='flex-end'>
            <Grid item container xs={6} direction='column' style={{textAlign: 'right'}}>
              <Typography style={{fontWeight: 'bold', fontSize: 16, marginBottom: 10}}>{data[0]['totalTitle']}</Typography>
              <Typography style={{fontWeight: 'bold', fontSize: 40}}>{data[0].value}</Typography>
            </Grid>
            <Grid item container xs={6}>
              <Typography style={{color: COLOR.GREEN, fontWeight: 'bold', fontSize: 20, whiteSpace: 'pre'}}>{data[0]['greenTitle']}</Typography>
            </Grid>
          </Grid>
        </Grid>
        :
        <>
          <Grid style={{width: '30%', paddingRight: 80, textAlign: 'center'}}>
            <MainHeading>{title}</MainHeading>
          </Grid>
          <Grid >
            <DashboardChartPie data={hasData ? data : []} {...props} />
            {children}
          </Grid>
        </>
      }
      {props.showTotal && !(data.length > 0 && data[0].singleTotal) && <Grid container item justifyContent='center' style={{marginTop: 20}}>
        <Typography style={{fontWeight: 'bold'}}>Total: {total}</Typography>
      </Grid>}
    </WidgetContainer>
  );
};

export default DashboardChartPieWidget;
